import dayjs from 'dayjs';

export const compareTime = (time1: string, time2: string) => {
  const date1 = new Date('1970-01-01T' + time1 + 'Z');
  const date2 = new Date('1970-01-01T' + time2 + 'Z');
  const res = dayjs(date1).isBefore(dayjs(date2));
  return res;
};
